import React, { useCallback, useState } from 'react';
import { Clickable } from '@moda/om';
import { ModalOverlay } from '../Modal';
import { EstimatedVat } from './EstimatedVat';

import './EstimatedVatLink.scss';

type Price = {
  currency: string | null;
  price: string | number | null;
};

type Props = {
  currentPrice: Price;
  vatPrice: Price;
  onClose?(): void;
};

export const EstimatedVatLink: React.FC<Props> = ({ currentPrice, vatPrice }) => {
  const [showVat, setShowVat] = useState(false);
  const handleClose = useCallback(() => setShowVat(false), []);

  return (
    <>
      <Clickable className="EstimatedVatLink" onClick={() => setShowVat(true)}>
        Includes VAT*
      </Clickable>

      <ModalOverlay onClose={handleClose} show={showVat}>
        <EstimatedVat
          currentPrice={currentPrice}
          vatPrice={vatPrice}
          onClose={() => setShowVat(false)}
        />
      </ModalOverlay>
    </>
  );
};
